export const toRp = (param: number) => {
  let currency = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  });
  return currency
    .format(param)
    .replace(/^(\D+)/, "$1")
    .replace(/\s+/, ". ");
};

export const formatValue = (val: string) => {
  const formattedValue =
    val === "" ? "" : parseInt(val).toLocaleString("en-US").replace(/\D/g, ".");
  return formattedValue;
};

export const formatPhoneNumber = (val?: string) => {
  if (!val) return "";
  const digits = val.replace(/\D/g, "");
  const local = digits.startsWith("62") ? digits.slice(2) : digits;
  if (!local) return "";

  const groups = [local.slice(0, 3)];
  for (let i = 3; i < local.length; i += 4) {
    groups.push(local.slice(i, i + 4));
  }

  return `(+62)-${groups.filter(Boolean).join("-")}`;
};
